export default __webpack_public_path__ + "static/media/WhiteLogo.fead875a.svg";